unit ErrorType;
{

/* Initial. */

}
interface

uses
  JS;

type
  TErrorType = class
  private
    fCode: String;
    fMessage: String;
  public
    property Code: String read fCode;
    property Message: String read fMessage;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TErrorType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fCode := String(JSObject_Type['code']);
    fMessage := String(JSObject_Type['message']);
  end;
end;

end.
